import productDataFilter from "../../shared/productDataFilter";
import moment from "moment";
import {
  fetchCartItem,
  getPartnerInfo,
  addToCartService,
  removeCartService,
  finalCheckout,
  orderValidation,
  finalTransactionBenefits,
  fetchCoupon,
  createOrder,
  fetchBankDetails,
  clearCart,
  stripeCheckoutApi,
  storeListApi,
  sellerDetailsApi,
} from "./checkout.services";
export default {
  namespaced: true,
  state: {
    cartData: [],
    checkoutData: {},
    createdOrderData: [],
    partnerInfo: [],
    selfPick: false,
    allowPickupFromShop: "",
    date: new Date(),
    isSelfPickUp: false,
    transactionBenefits: {},
    couponList: [],
    couponLoading: true,
    checkoutLoading: true,
    selectedCoupon: {},
    paymentMethodClick: "",
    storeList: [],
    selectedStoreAddress: {},
    timeSlot: {},
    providerData: {},
  },
  getters: {},
  actions: {
    resetCartData(context) {
      context.state.cartData = [];
    },
    updateTimeSlot(context, payload) {
      context.state.timeSlot = payload;
    },
    updatePaymentClick(context, payload) {
      context.state.paymentMethodClick = payload;
    },
    updateSelectedStore(context, payload) {
      context.commit("setSelectedStore", payload);
    },
    async addToCartBulk(context, payload) {
      await addToCartService({
        item: payload._id,
        quantity: payload.qty,
      });
    },
    async getAccountDetails(context, payload) {
      let res = await fetchBankDetails(payload);
      return res;
    },
    async fetchStripeCheckoutInfo(context, payload) {
      return await stripeCheckoutApi(payload);
    },
    async clearCart(context) {
      try {
        let clr = await clearCart();
        context.commit("setCartData", []);
        // context.dispatch("checkoutFinal");
        return clr;
      } catch (err) {
        return err;
      }
    },

    async removeItem(context, { cartItem, callApi }) {
      //   if (this.state.auth.isLoggedin) {
      if (callApi)
        await removeCartService({
          item: cartItem._id,
          quantity: cartItem.qty,
        });

      const filteredData = this.state?.checkout?.cartData.filter(
        (item) => item._id !== cartItem._id,
      );
      await context.commit("setCartData", filteredData);
    },
    async createOrderAction({ state, commit }) {
      try {
        // Validate required state properties
        if (!state.checkoutData || !this.state.auth?.userInfo?.authentication) {
          throw new Error("Missing required customer information");
        }

        // Validate address objects are not empty
        if (
          !state.providerData?.office?.address ||
          Object.keys(state.providerData?.office?.address).length === 0
        ) {
          throw new Error("Store address not found");
        }
        if (
          !state.isSelfPickUp && // Only check delivery address if NOT self-pickup
          (!this.state.address?.defaultAddress?.location ||
            Object.keys(this.state.address?.defaultAddress?.location).length ===
              0)
        ) {
          throw new Error("Delivery address not available");
        }

        // Validate pickup slot for self-pickup orders
        if (state.isSelfPickUp && !state.timeSlot) {
          throw new Error(
            "Missing pickup slot information for self-pickup order",
          );
        }

        // Prepare address data based on pickup type
        let addressData;
        if (state.isSelfPickUp) {
          addressData = {
            address: { ...state.providerData?.office?.address },
            loc: { ...state.providerData?.office?.address?.location },
          };
        } else {
          addressData = {
            address: { ...this.state.address?.defaultAddress },
            loc: { ...this.state.address?.defaultAddress?.location },
          };
        }

        // Validate address data
        if (!addressData.address || !addressData.loc) {
          throw new Error("Invalid address data");
        }

        // Construct payload
        const payloadData = {
          customerDetails: {
            orderAmount: state.checkoutData.totalPrice || 0,
            customerName: this.state.auth.userInfo.authentication.userName,
            customerPhone: this.state.auth.userInfo.authentication.phone,
            customerEmail: this.state.auth.userInfo.authentication.email,
          },
          custom: {
            shipper: {
              address:
                state.providerData?.office?.address ||
                this.state.home.tenantDetails?.address,
              contact: {
                ...state.providerData?.authentication,
                phone: state.providerData?.authentication?.phone
                  .replace(/[\s().-]/g, "")
                  .slice(-10),
              },
            },
            recipients: { ...this.state.address?.defaultAddress },
          },
          orderDetails: {
            paymentType: state.checkoutData?.payment?.type,
            deliveryAddress: addressData,
            items: state.checkoutData?.items || [],
          },
          txData: {
            orderId: state.checkoutData?.payment?.orderId || "",
            referenceId: "",
            txStatus: "",
            txMsg: "",
            txTime: "",
            signature: "",
            PaymentServiceName: "",
          },
          createdAt: state.checkoutData?.createdAt,
          payments: state.checkoutData?.payments,
          payment: state.checkoutData?.payment,
          orderHash: state.checkoutData?.hash,
          totalPriceBeforeTax: state.checkoutData?.totalPriceBeforeTax || 0,
          isNew: true,
        };

        // Add pickup slot for self-pickup orders
        if (state.isSelfPickUp) {
          payloadData.custom.pickupSlot = { ...state.timeSlot };
        }

        // Make API call
        const orderResponse = await createOrder(payloadData);

        if (!orderResponse?.data?.response) {
          throw new Error("Invalid order response from server");
        }

        // Update state and clear cart
        commit("setCreatedOrderData", orderResponse.data.response);
        // Consider moving cart clearing to a separate action
        // await dispatch('clearCart');

        return orderResponse;
      } catch (err) {
        throw Error(
          err?.response?.data?.message ||
            `Api failed with error: ${err.message}`,
        );
      }
    },
    async validateOrderAction(context, payload) {
      try {
        let validation = await orderValidation(payload);
        await clearCart();
        context.state.cartData = [];
        return validation;
      } catch (error) {
        return error;
      }
    },
    async fetchCouponList(context) {
      context.state.couponLoading = true;
      let res = await fetchCoupon();
      context.state.couponLoading = false;
      context.commit("setCopunList", res?.data?.response);
    },
    fetchCartData: async (context, payload) => {
      let result = await fetchCartItem(payload);
      if (
        result?.data?.response?.items &&
        Array.isArray(result?.data?.response?.items) &&
        result?.data?.response?.items.length
      ) {
        context.dispatch(
          "fetchSellerDetails",
          result?.data?.response?.items[0].provider,
        );
      }
      try {
        result = productDataFilter.methods.filterProductData(
          result.data.response?.items,
        );
      } catch (err) {
        console.log(err);
      }
      // experiemt code
      let cartData = context.state.cartData;
      let resStore = result;
      if (Array.isArray(cartData) && cartData.length > 0) {
        if (Array.isArray(result) && result.length > 0) {
          await cartData.forEach(async (el) => {
            if (resStore.some((i) => i._id == el._id)) {
              await resStore.forEach(async (resEl) => {
                if (resEl._id == el._id) {
                  let qty = el.qty - resEl.qty;
                  if (qty > 0) {
                    await addToCartService({
                      item: el._id,
                      quantity: qty,
                    });
                  } else if (qty < 0) {
                    await removeCartService({
                      item: el._id,
                      quantity: Math.abs(qty),
                    });
                  }
                  resEl.qty = el.qty;
                }
              });
              context.commit("setCartData", result);
            } else {
              await addToCartService({
                item: el._id,
                quantity: el.qty,
              });
              result.push(el);
              context.commit("setCartData", result);
            }
          });
        } else {
          await cartData.forEach(async (el) => {
            await addToCartService({
              item: el._id,
              quantity: el.qty,
            });
          });
          result = cartData;

          context.commit("setCartData", result);
        }
      }
      //   end
      context.commit("setCartData", result);
    },
    async increaseCartQty(
      context,
      { cartItem, callApi, itemId = null, quantity = 1 },
    ) {
      //   if (this.state.auth.isLoggedin) {
      if (callApi)
        await addToCartService({
          item: itemId || cartItem._id,
          quantity,
        });
      // await context.dispatch(
      //   "checkout/fetchCartData",
      //   {
      //     shipFrom: "US",
      //     shipTo: "US",
      //     country: "US",
      //   },
      //   { root: true }
      // );
      //   } else {
      if (
        this.state?.checkout?.cartData.some((item) => item._id == cartItem._id)
      ) {
        context.commit("setIncreaseQtyToStore", cartItem);
      } else {
        cartItem.qty = quantity;
        this.state.checkout.cartData.push(cartItem);
      }
      //}
    },
    async decreaseCartQty(context, { cartItem, callApi }) {
      //   if (this.state.auth.isLoggedin) {
      if (callApi)
        await removeCartService({
          item: cartItem._id,
          quantity: 1,
        });
      // await context.dispatch(
      //   "checkout/fetchCartData",
      //   {
      //     shipFrom: "US",
      //     shipTo: "US",
      //     country: "US",
      //   },
      //   { root: true }
      // );
      //   } else {
      if (
        this.state?.checkout?.cartData.some((item) => item._id == cartItem._id)
      ) {
        await context.commit("setDecreaseQtyToStore", cartItem);
        await context.commit("setCartData", this.state.checkout.cartData);
      }
      // }
    },
    async selectCoupon(context, payload) {
      context.commit("updateselectedCoupon", payload);
      context.dispatch("checkoutFinal");
    },
    async checkoutFinal({ state, commit }) {
      // Validate user authentication information
      if (!this.state.auth?.userInfo?.authentication) {
        throw new Error("Missing required customer information");
      }

      // Validate checkout data
      if (!state.checkoutData) {
        throw new Error("Missing required checkout data");
      }

      // Determine address based on pickup type
      let addr;
      if (state.isSelfPickUp) {
        addr = state.providerData?.office?.address || {};
      } else {
        addr =
          this.state.address?.defaultAddress &&
          Object.keys(this.state.address?.defaultAddress).length
            ? this.state.address?.defaultAddress
            : {};
      }

      // Validate address
      if (!addr || Object.keys(addr).length === 0) {
        commit("setCheckoutData", {});
        state.checkoutLoading = "errorAddress";
        // const msg = state.isSelfPickUp
        //   ? "Store address not available"
        //   : "Delivery address not available";
        // throw new Error(msg);
        return;
      }

      // Validate and extract location data
      if (
        !addr.location?.coordinates ||
        addr.location?.coordinates.length < 2
      ) {
        throw new Error("Invalid or missing address coordinates");
      }

      // Validate pickup time for self-pickup orders
      if (state.isSelfPickUp && !state.date) {
        throw new Error("Missing pickup time for self-pickup order");
      }

      // Validate cart data for STRIPE or PAYPAL
      if (!state.cartData?.length) {
        throw new Error("Cart is empty or invalid");
      }

      try {
        // Construct payload
        const payload = {
          location: {
            long: addr.location?.coordinates[0],
            lat: addr.location?.coordinates[1],
            zip: addr.zip,
            state: addr.state,
            city: addr.city,
          },
          checkout: {
            type: state.paymentMethodClick || "COD",
            customerNo: this.state.auth?.userInfo?.customerNo,
            userEmail: this.state.auth?.userInfo?.authentication?.email,
            userPhone: this.state.auth?.userInfo?.authentication?.phone,
          },
          isSelfPickUp: this.state.isSelfPickUp,
        };

        // Add pickup time for self-pickup orders
        if (state.isSelfPickUp) {
          payload.isSelfPickUp = state.isSelfPickUp;
          payload.pickUpTime = state.date;
        }

        // Add coupon if available
        const coupon = state.checkout?.selectedCoupon || {};
        if (coupon.promoCode) {
          payload.couponCode = coupon.promoCode;
        }

        // Handle specific payment method configurations
        if (state.paymentMethodClick === "CASHFREE") {
          payload.isMobile = false;
        } else if (
          state.paymentMethodClick === "STRIPE" ||
          state.paymentMethodClick === "PAYPAL"
        ) {
          const currencyCode = this.state.home?.currency?.code || "USD";
          payload.platform = "web";
          payload.productName = state.cartData[0]?.description_summary;
          payload.qty = state.cartData?.length.toString() || "1";
          payload.currency = currencyCode;
          payload.amount =
            parseFloat(state.checkoutData?.totalPrice?.toFixed(1)) || 0;
          payload.payment = {
            redirect_on_completion: "always",
            returnUrl: `${window.location.origin}#/order-verify`,
          };
        }

        // Execute checkout
        state.checkoutLoading = true;
        commit("setCheckoutData", {});
        const res = await finalCheckout(payload);

        if (!res?.data) {
          throw new Error("Invalid checkout response from server");
        }

        commit("setCheckoutData", res.data);
        state.checkoutLoading = false;

        return res;
      } catch (error) {
        state.checkoutLoading = "errorAddress";
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`,
        );
      }
    },

    async transactionBenefitsFinal(context) {
      try {
        let payload = {
          orderAmount: this.state?.checkout?.checkoutData?.listPrice || "",
          provider: this.state?.checkout?.cartData[0]?.provider,
        };
        await finalTransactionBenefits(payload)
          .then((res) => {
            context.commit("setTransactionBenefits", res.data.response);
          })
          .catch((err) => {
            console.log("err", err);
          });
      } catch (err) {
        return err;
      }
    },
    fetchPartnerInfo: async (context, payload) => {
      let res = await getPartnerInfo(payload);
      context.commit("setPartnerInfo", res);
    },
    fetchStoreList: async (context, id) => {
      try {
        let res = await storeListApi(id);
        const list = res.map((el) => {
          return { _id: el._id, ...el.office, ...el.dist };
        });
        context.commit("setStoreList", list);
        return res;
      } catch (error) {
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`,
        );
      }
    },
    fetchSellerDetails: async (context, id) => {
      if (context.state.providerData?._id === id) return;
      try {
        let res = await sellerDetailsApi(id);
        context.commit("setProviderDetails", res.data.response);
        return res;
      } catch (error) {
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`,
        );
      }
    },
  },
  mutations: {
    setPickupStatus(state, payload) {
      state.isSelfPickUp = payload.selected;
      state.date = payload.pickup || state.date;
    },
    updateselectedCoupon(state, payload) {
      state.selectedCoupon = payload;
    },
    async setCopunList(state, payload) {
      let filteredCoupon = [];

      await payload.forEach((el) => {
        if (
          !el.isDeleted &&
          el.isApproved &&
          moment().isBetween(el?.promoRules?.startDate, el?.promoRules?.endDate)
        ) {
          filteredCoupon.push(el);
        }
      });
      state.selectedCoupon = filteredCoupon.length > 0 ? filteredCoupon[0] : {};
      state.couponList = filteredCoupon;
    },
    setCheckoutData(state, payload) {
      state.checkoutData = payload;
    },
    setProviderDetails(state, payload) {
      state.providerData = payload;
    },
    setCreatedOrderData(state, data) {
      state.createdOrderData = data;
    },
    setTransactionBenefits(state, payload) {
      state.transactionBenefits = payload;
    },
    setCartData: async (state, payload) => {
      let filterData = [];
      state.cartData = [];
      await payload.forEach((element) => {
        if (element?.qty && element.qty > 0) {
          filterData.push(element);
        }
      });
      state.cartData = filterData;
    },
    setPartnerInfo: (state, data) => {
      state.allowPickupFromShop = data.preferences.delivery.allowPickupFromShop;
      state.partnerInfo = data.preferences.paymentMethod;
    },
    setStoreList: (state, data) => {
      state.storeList = data;
    },
    setSelectedStore: (state, data) => {
      state.selectedStoreAddress = data;
    },
    async setIncreaseQtyToStore(state, payload) {
      let data = this.state?.checkout?.cartData || [];
      await data.map((el) => {
        if (el._id == payload._id) {
          el.qty = parseInt(el.qty);
          //   let price =
          //     el.unitDiscountedPrice > 0 ? el.unitDiscountedPrice : el.unitPrice;
          el.qty += 1;
          el.unitAmount += el.unitPrice;
        }
      });
      state.cartData = data;
    },

    async setDecreaseQtyToStore(state, payload) {
      let data = this.state?.checkout?.cartData || [];
      await data.map((el) => {
        if (el._id == payload._id) {
          el.qty = parseInt(el.qty);
          //   let price =
          //     el.unitDiscountedPrice > 0 ? el.unitDiscountedPrice : el.unitPrice;
          el.qty -= 1;
          el.unitAmount -= el.unitPrice;
        }
      });
      state.cartData = data;
    },
  },
};
